<div class="container-fluid vh-auto font-name">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="course-heading text-start">Create New Course</h3>
  </div>
  <p class="sub-head text-start">
    Create your course step-by-step by adding chapters, topics, and duration.
  </p>

  <div class="thumbnail-wrapper">
    <label class="thumbnail-label">Course Thumbnail</label>

    <div
      class="upload-box"
      (click)="fileInput.click()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onFileDrop($event)"
      [class.dragging]="isDragging">

      <input
        type="file"
        #fileInput
        accept="image/png,image/jpeg"
        hidden
        (change)="onFileSelect($event)" />

      <div class="upload-content">
        <div class="upload-icon">⬆️</div>
        <p class="upload-title">Click to upload or drag and drop</p>
        <p class="upload-subtitle">
          PNG, JPG up to 5MB (1280×720 recommended)
        </p>

        <p class="file-name" *ngIf="selectedFile">
          {{ getSelectedFileName() }}
        </p>
      </div>
    </div>
  </div>

  <!-- FORM -->
  <div class="modal-form mb-3">
    <form [formGroup]="createCourseForm">

      <div class="mb-4">
        <label>Course Title <span class="text-danger">*</span></label>

        <input
          type="text"
          class="form-control"
          formControlName="course_title"
          maxlength="80"
          placeholder="Ex: Introduction to Science" />

        <small class="text-muted">
          {{ createCourseForm.get('course_title')?.value?.length || 0 }}/80
        </small>

        <small
          *ngIf="createCourseForm.get('course_title')?.touched &&
                 createCourseForm.get('course_title')?.invalid"
          class="text-danger">
          Title is required and must be under 80 characters 
        </small>
      </div>

      <div class="mb-4">
        <label>Course Code <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          formControlName="course_code"
          placeholder="e.g., GENAI101" />
      </div>

      <div class="mb-4">
        <label>Course Description <span class="text-danger">*</span></label>

        <textarea
          class="form-control mb-2"
          rows="4"
          formControlName="course_description"
          maxlength="280"
          placeholder="Describe what students will learn in this course">
        </textarea>

        <small class="text-muted">
          {{ createCourseForm.get('course_description')?.value?.length || 0 }}/280
        </small>

        <small
          *ngIf="createCourseForm.get('course_description')?.touched &&
                 createCourseForm.get('course_description')?.invalid"
          class="text-danger">
          Description is required and must be under 280 characters
        </small>
      </div>

      <!-- GRADE -->
      <div class="mb-4">
        <label>Grade <span class="text-danger">*</span></label>

        <select formControlName="grade_level" class="form-control">
          <option value="" disabled>Select grade</option>
          <option value="Beginner">Beginner</option>
          <option value="Intermediate">Intermediate</option>
          <option value="Advanced">Advanced</option>
        </select>
      </div>

      <div class="col-md-4">
        <label>Rating (Optional)</label>
        <input
          type="number"
          class="form-control"
          formControlName="rating"
          placeholder="e.g., 4"
          min="1"
          max="5" />

        <small
          *ngIf="createCourseForm.get('rating')?.touched &&
                 createCourseForm.get('rating')?.invalid"
          class="text-danger">
          Rating must be between 1 and 5
        </small>
      </div>

    </form>
  </div>

  <div class="d-flex justify-content-end">
	<button type="submit" class="btn-add" (click)="goToNextPage()" [disabled]="createCourseForm.invalid">
    Next <mat-icon class="icon-middle">chevron_right</mat-icon>
  </button>
  </div>
</div>